// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c61c47d3","732":"0b5ffa3c","977":"463729d6"}[chunkId] + ".chunk.js";
};